export default {
      id: "logout-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#logout",
      toString: function () {
        return this.url;
      }
    }